import http from "../../../../lib/http/httpClient";
import { Customer, Division } from "../../../../types/settings";

export const getCustomers = async (): Promise<Customer[]> => {
    return http.get("/api/v1/cp/customers");
};

export const getDivisions = async (custId?: string): Promise<Division[]> => {
    const params = new URLSearchParams(custId ? { cust: custId } : {});
    return http.get(`/api/v1/cp/divisions/all${params.toString() ? `?${params}` : ""}`);
};

export const createCustomer = async (payload: {
    cust_id: string;
    cust_name: string;
}) => {
    return http.post("/api/v1/cp/customers", payload);
};

export const createDivision = async (payload: {
    cust_id: string;
    divn_id: number;
    divn_name: string;
}) => {
    return http.post("/api/v1/cp/divisions", payload);
};
